module.exports = __webpack_public_path__ + "img/slide04.792fbe33.jpg";